// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tabs--left .el-tabs__item.is-left {\n  text-align: left;\n}\n.el-tabs--left .el-tabs__header.is-left {\n  width: 100%;\n}\n.father1 {\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
